// Auto generated file, do not manually modify!
// com.hotpads.screening.client.background.enums.CicBackgroundReportStatus

export enum CicBackgroundReportStatus {
  AVAILABLE = 'AVAILABLE',
  EXPIRED = 'EXPIRED',
  INVALID_DOB = 'INVALID_DOB',
  INVALID_SSN = 'INVALID_SSN',
  INVALID_SSN_DOB = 'INVALID_SSN_DOB',
  IN_DISPUTE = 'IN_DISPUTE',
  MANUAL_REVIEW = 'MANUAL_REVIEW',
  NOT_AVAILABLE = 'NOT_AVAILABLE',
  NO_DOB = 'NO_DOB',
  NO_SSN = 'NO_SSN',
  NO_SSN_DOB = 'NO_SSN_DOB',
  REAUTHENTICATING = 'REAUTHENTICATING',
  REGULATORY_RESTRICTIONS = 'REGULATORY_RESTRICTIONS',
  SECURITY_FREEZE = 'SECURITY_FREEZE',
  SERVICE_FAILED = 'SERVICE_FAILED',
}

export const CicBackgroundReportStatus_values = [
  CicBackgroundReportStatus.AVAILABLE,
  CicBackgroundReportStatus.EXPIRED,
  CicBackgroundReportStatus.INVALID_DOB,
  CicBackgroundReportStatus.INVALID_SSN,
  CicBackgroundReportStatus.INVALID_SSN_DOB,
  CicBackgroundReportStatus.IN_DISPUTE,
  CicBackgroundReportStatus.MANUAL_REVIEW,
  CicBackgroundReportStatus.NOT_AVAILABLE,
  CicBackgroundReportStatus.NO_DOB,
  CicBackgroundReportStatus.NO_SSN,
  CicBackgroundReportStatus.NO_SSN_DOB,
  CicBackgroundReportStatus.REAUTHENTICATING,
  CicBackgroundReportStatus.REGULATORY_RESTRICTIONS,
  CicBackgroundReportStatus.SECURITY_FREEZE,
  CicBackgroundReportStatus.SERVICE_FAILED,
] as const;
